/* import __COLOCATED_TEMPLATE__ from './cta-link.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { assert } from '@ember/debug';

/**
## EventTimeline/Link

Link that supports both actions and URLs for use in the event-timeline component.

@param {String} linkClass - CSS class to apply to link
@param {String} callToAction.text - text for the call to action
@param {String} callToAction.href - URL if call to action should be a link (cannot be used with `callToAction.action`)
@param {Action} callToAction.action - action if there is a call to action (cannot be used with `callToAction.href`)
*/
let CtaLink = (_dec = tagName(''), _dec(_class = class CtaLink extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "linkClass", null);
    _defineProperty(this, "callToAction", null);
  }
  init(...args) {
    super.init(...args);
    const {
      href,
      action
    } = this.callToAction;
    assert('{{event-timeline/cta-link}} cannot does not support both `href` and `action`', !(href && action));
    assert('{{event-timeline/cta-link}} requires either `href` or `action`', href || action);
  }
}) || _class);
export { CtaLink as default };